import { Location } from '../../types/models/Location.model'
import { Term } from '@/types/models'
import { getLocationParts, getTitle } from '../location'
import transformTextToSlug from '../../utils/transformTextToSlug'
import { BreadCrumbs } from './computeBreadCrumbs'
import { TermPageType } from '../../types/models/PageType.model'
import {
  UNITED_STATES,
  NORTH_AMERICA,
  BANNED_BREADCRUMBS_LOCATION_TITLES_ON_FACETS
} from '../location/constants'
import computeIsLuxury from '../useCases/term/computeIsLuxury'

interface ComputeFacetBreadCrumbs {
  (props: { location: Location; term: Term; isV2?: boolean }): {
    breadCrumbs: BreadCrumbs
    selectedTitle: string
  }
}

const computeFacetBreadCrumbs: ComputeFacetBreadCrumbs = ({
  location,
  term
}) => {
  let breadCrumbs: BreadCrumbs = []

  const locationTitle = getTitle(location)
  const taxonomyPageSlug = TermPageType[term.type]
  const selectedTitle = locationTitle === NORTH_AMERICA ? '' : locationTitle
  const termBreadCrumbSlug = computeIsLuxury(term)
    ? term.slug
    : `${taxonomyPageSlug}/${term.slug}`

  const termBreadcrumb = {
    slug: taxonomyPageSlug ? termBreadCrumbSlug : '',
    title: term.title
  }

  if (locationTitle !== UNITED_STATES) {
    breadCrumbs.push(termBreadcrumb)
  }

  const locationParts = getLocationParts(location)

  breadCrumbs = breadCrumbs.concat(
    locationParts
      .map((part) => ({
        title: part.title || '',
        slug: `${part?.slug || transformTextToSlug(part.title)}/${term.slug}`,
        type: part.type
      }))
      .filter(
        (item) => !BANNED_BREADCRUMBS_LOCATION_TITLES_ON_FACETS.has(item.title)
      )
  )

  return {
    breadCrumbs,
    selectedTitle
  }
}

export default computeFacetBreadCrumbs
